module.exports = __webpack_public_path__ + "static/media/03.4b1cfc23.jpg";